import { h } from 'preact';

import { withShowtimesBehavior } from 'components/editor/movies/showtimes/showtimes';
import FocusWatchPageEditor from 'components/editor/movies/watch/watchFocus';

import s from 'components/editor/movies/showtimes/showtimesFocus.sss';

export default class FocusShowtimesEditor extends withShowtimesBehavior(FocusWatchPageEditor) {
	s = s; // Styling will only be assigned in the final implementation (i.e. showtimesFocus.js)

	renderSearch() {
		return (
			<div class={this.s.search}>
				<div class={this.s.searchWrapper}>
					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
						<path d="M14.854 14.146L10.726 10.018C11.521 9.065 12 7.839 12 6.5C12 3.462 9.538 1 6.5 1C3.462 1 1 3.462 1 6.5C1 9.538 3.462 12 6.5 12C7.839 12 9.065 11.521 10.019 10.726L14.147 14.854C14.244 14.951 14.372 15 14.5 15C14.628 15 14.756 14.951 14.854 14.854C15.049 14.658 15.049 14.342 14.854 14.146ZM6.5 11C4.019 11 2 8.981 2 6.5C2 4.019 4.019 2 6.5 2C8.981 2 11 4.019 11 6.5C11 8.981 8.981 11 6.5 11Z" />
					</svg>
					<div class={this.s.city}>{this.state.geo.city}</div>
				</div>
				{this.renderFiltersButton()}
			</div>
		);
	}

	renderFilters() {
		return (
			<div class={this.s.filters}>
				{this.renderQuickFilters()}
			</div>
		);
	}
}